import { executeApiRequest } from './../middleware/api'

const get = () => executeApiRequest({ method: 'get', url: '/api/semesters' })

export default {
  get,
}
